import React, { useCallback, useRef } from 'react';
import cx from 'clsx';

import { IconRcArrowDown } from '@/assets/common';

import style from './index.module.scss';
import { useSwitch } from '@/hooks';

type SelectProps = {
  options?: Array<string | number>;
  value?: string | number;
  onChange?(arg: string): void;
  className?: string;
  title?: string;
  disabled?: boolean;
};

export const Select = ({ options, className, title, onChange, value, disabled }: SelectProps) => {
  const ref = useRef<HTMLSelectElement>(null);
  const { on: isFocused, turnOn: focus, turnOff: blur } = useSwitch();

  const handleChange = useCallback(
    ({ currentTarget }: React.ChangeEvent<HTMLSelectElement>) => {
      if (disabled) {
        return;
      }

      var value = currentTarget.options[currentTarget.selectedIndex].value;

      onChange?.(value);
    },
    [disabled],
  );

  const handleClick = useCallback(() => {
    if (disabled) {
      return;
    }

    ref.current?.focus();
  }, [disabled]);

  return (
    <div
      className={cx(
        style.container,
        isFocused && style.isFocused,
        disabled && style.isDisabled,
        className,
      )}
      onClick={handleClick}>
      <label dir="ltr" className={style.label}>
        <span className={style.title}>{title}</span>
      </label>
      <select
        className={style.select}
        onChange={handleChange}
        value={value}
        onFocus={focus}
        onBlur={blur}
        ref={ref}
        disabled={disabled}>
        {options?.map((x, i) => (
          <option value={x} key={`${x}_${i}`} className={style.option}>
            {x}
          </option>
        ))}
      </select>
      <IconRcArrowDown className={style.arrowIcon} />
    </div>
  );
};
